<template>
  <div class="form-group" v-bind:class="{ error: error[0] }">
    <label for="phone">Телефон</label>
    <input
      type="text"
      class="form-control"
      id="phone"
      placeholder="Введите телефон"
      v-bind:value="value"
      v-on:input="updateValue($event.target.value)"
    >
    <div class="error">{{ error[0] }}</div>
  </div>
</template>

<script>
export default {
  name: 'phone-field',
  props: {
    value: String,
    error: Array
  },
  methods: {
    updateValue (value) {
      this.$emit('input', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Phone.vue?3582b70b